<template>
  <div>
    <FrmManageVehicles
      show-select= true
      v-on:item-selected="selectedCallback"
       v-bind:selected-vehicles="selectVehicles"
    ></FrmManageVehicles>
  </div>
</template>


 <style lang="">
</style> 
<script>
import FrmManageVehicles from "../../Management/FrmManageVehicles";

export default {
  props: ["eventInfo","events"],
  components: {
    FrmManageVehicles,
  },
  watch:{
    eventInfo:function(value,old){
      console.debug("value");
      console.debug(value);
       this.selectVehicles=value.risorseIntervento.filter((r)=>r.risorsa.tipo=="Mezzo").map((r)=>r.risorsa);
    }
  },
    
  data: () => ({
    selectVehicles: []
  }),
   methods: {
    selectedCallback: function (selectedItems) {

      this.eventInfo.risorse=this.eventInfo.risorse.filter((r)=>r.tipo!="Mezzo");
      for(let i=0;i<selectedItems.length;i++)
        this.eventInfo.risorse.push(selectedItems[i]);
      console.log(selectedItems);
      this.selectVehicles=selectedItems;
    },
  },
};
</script>

